import { parseApiDateTimeValue } from '@/lib/org-date-locale'

type CompactTableDateProps = {
  value?: string | null
  includeTime?: boolean
  includeYear?: boolean
  includeWeekday?: boolean
  locale?: string
  timeZone?: string
}

export { parseApiDateTimeValue }

export function CompactTableDate({
  value,
  includeTime = true,
  includeYear = true,
  includeWeekday = false,
  locale,
  timeZone,
}: CompactTableDateProps) {
  if (!value) {
    return <span className="text-muted-foreground">-</span>
  }

  const parsed = parseApiDateTimeValue(value)
  if (!parsed) {
    return <span className="text-muted-foreground">-</span>
  }

  const dateLabel = parsed.toLocaleDateString(locale, {
    weekday: includeWeekday ? 'short' : undefined,
    day: '2-digit',
    month: 'short',
    year: includeYear ? 'numeric' : undefined,
    timeZone,
  })

  if (!includeTime) {
    return <span className="text-xs font-medium text-foreground">{dateLabel}</span>
  }

  return (
    <span className="flex flex-col gap-0.5">
      <span className="text-xs font-medium text-foreground">{dateLabel}</span>
      <span className="text-xs text-muted-foreground">
        {parsed.toLocaleTimeString(locale, {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
          timeZone,
        })}
      </span>
    </span>
  )
}

/** Matches bookings/orders table wrapper typography. */
export const commerceTableClassName = 'text-sm leading-5'
